import { render, staticRenderFns } from "./UpdateCredentialsNotification.vue?vue&type=template&id=58857d30&scoped=true&"
import script from "./UpdateCredentialsNotification.vue?vue&type=script&lang=js&"
export * from "./UpdateCredentialsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58857d30",
  null
  
)

export default component.exports